function hover_img_changer(el) {

  let opts;
  let hover_el = el;

  // item_settings()
  // -------------------------------------

  function item_settings() {
    opts = {
      img_el: null,
      img_src_string: null,
    };


    // set_opt() - && set options object
    // -------------------------------------

    function set_opt(opt_name, attr, callback = null) {
      if (hover_el.hasAttribute(attr)) {
        opts[opt_name] = callback ? callback(el.getAttribute(attr)) : hover_el.getAttribute(attr);
      }
    }
    set_opt('img_el',         'data-js-hover-img-changer-el');
    set_opt('img_src_string', 'data-js-hover-img-changer-img');

    opts.img_el = document.getElementById(opts.img_el);
  }


  function bind() {
    console.log(hover_el);
    hover_el.addEventListener('mouseover', () => {
      opts.img_el.style.backgroundImage = 'url(' + opts.img_src_string + ')';
    });
  }



  // init()
  // -------------------------------------

  function init() {
    item_settings();

    if (!opts.img_el) {
      return false;
    }

    bind();


  }
  init();
}


function init_all() {
  const items = Array.from(document.querySelectorAll('[data-js-hover-img-changer]'));

  // console.log(items);
  items.forEach(hover_img_changer);
}
init_all();
